import { useState } from 'react';
import moment from 'moment-timezone';
export var DATE_RANGE;
(function (DATE_RANGE) {
    DATE_RANGE["ALL"] = "ALL";
    DATE_RANGE["TODAY"] = "TODAY";
    DATE_RANGE["LAST_SEVEN_DAYS"] = "LAST_SEVEN_DAYS";
    DATE_RANGE["LAST_FOUR_WEEKS"] = "LAST_FOUR_WEEKS";
    DATE_RANGE["LAST_THREE_MONTHS"] = "LAST_THREE_MONTHS";
    DATE_RANGE["LAST_TWELVE_MONTHS"] = "LAST_TWELVE_MONTHS";
    DATE_RANGE["MTD"] = "MTD";
    DATE_RANGE["QTD"] = "QTD";
    DATE_RANGE["YTD"] = "YTD";
    DATE_RANGE["SYTD"] = "SYTD";
    DATE_RANGE["CUSTOM"] = "CUSTOM";
})(DATE_RANGE || (DATE_RANGE = {}));
const DATE_RANGE_DATA = {
    ALL: {
        label: 'All time',
        getRange: () => [moment({ year: 2023 }), moment().endOf('day')]
    },
    TODAY: {
        label: 'Today',
        getRange: () => [moment().startOf('day'), moment().endOf('day')]
    },
    LAST_SEVEN_DAYS: {
        label: 'Last 7 days',
        getRange: () => [moment().subtract(7, 'days'), moment().endOf('day')]
    },
    LAST_FOUR_WEEKS: {
        label: 'Last 4 weeks',
        getRange: () => [moment().subtract(4, 'weeks'), moment().endOf('day')]
    },
    LAST_THREE_MONTHS: {
        label: 'Last 3 months',
        getRange: () => [moment().subtract(3, 'months'), moment().endOf('day')]
    },
    LAST_TWELVE_MONTHS: {
        label: 'Last 12 months',
        getRange: () => [moment().subtract(12, 'months'), moment().endOf('day')]
    },
    MTD: {
        label: 'Month to Date',
        getRange: () => [moment().startOf('month'), moment().endOf('day')]
    },
    QTD: {
        label: 'Quarter to Date',
        getRange: () => [moment().startOf('quarter'), moment().endOf('day')]
    },
    YTD: {
        label: 'Year to Date',
        getRange: () => [moment().startOf('year'), moment().endOf('day')]
    },
    SYTD: {
        label: 'School Year to Date',
        getRange: () => {
            if (moment().month() === 7 && moment().day() === 1)
                return [moment().startOf('day'), moment().endOf('day')];
            else if (moment().month() < 7)
                return [moment([moment().year() - 1, 7, 1]), moment().endOf('day')];
            else
                return [moment([moment().year(), 7, 1]), moment().endOf('day')];
        }
    },
    CUSTOM: {
        label: 'Custom',
        getRange: (customRange) => [
            moment(customRange === null || customRange === void 0 ? void 0 : customRange.from),
            moment(customRange === null || customRange === void 0 ? void 0 : customRange.to)
        ]
    }
};
export const createRangeList = (options) => {
    const obj = {};
    options.forEach((opt) => {
        if (DATE_RANGE_DATA[opt]) {
            obj[opt] = DATE_RANGE_DATA[opt].label;
        }
    });
    return obj;
};
export const DATE_RANGES = {
    PRIMARY: createRangeList([
        'ALL',
        'TODAY',
        'LAST_SEVEN_DAYS',
        'LAST_FOUR_WEEKS',
        'LAST_THREE_MONTHS',
        'LAST_TWELVE_MONTHS',
        'CUSTOM'
    ]),
    SECONDARY: createRangeList(['MTD', 'QTD', 'YTD', 'SYTD'])
};
export const useReportRange = (defaultRange = DATE_RANGE.LAST_SEVEN_DAYS) => {
    const [range, setRange] = useState(defaultRange);
    const [customRange, setCustomRange] = useState({
        from: DATE_RANGE_DATA[defaultRange].getRange()[0].toISOString(),
        to: DATE_RANGE_DATA[defaultRange].getRange()[1].toISOString()
    });
    return Object.assign(Object.assign({ range }, customRange), { setRange: (val) => {
            if (!Object.values(DATE_RANGE).includes(val))
                return;
            const newRange = val;
            setRange(newRange);
            if (newRange !== DATE_RANGE.CUSTOM) {
                const [newFrom, newTo] = DATE_RANGE_DATA[newRange].getRange().map((v) => v.toISOString());
                setCustomRange({ from: newFrom, to: newTo });
            }
        }, setCustomRange: (val) => {
            if (DATE_RANGE_DATA[range].getRange()[0].isSame(val.from, 'minute') &&
                DATE_RANGE_DATA[range].getRange()[1].isSame(val.to, 'minute'))
                return;
            setRange(DATE_RANGE.CUSTOM);
            setCustomRange(val);
        } });
};
//# sourceMappingURL=useReportRange.js.map